(() => {
  const email = 'ecustomerservice@sembonia.com';
  const pattern = /[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9-]+)+/gi;
  document.querySelectorAll('.sembonia-policy-content, .shopify-policy__body, [data-purchasing-terms-content]').forEach((content) => {
    const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.parentElement.closest('script,style,textarea')) continue;
      node.textContent = node.textContent.replace(pattern, email);
    }
    content.querySelectorAll('a[href]').forEach((link) => {
      const href = link.getAttribute('href');
      if (!/^mailto:/i.test(href)) return;
      const queryIndex = href.indexOf('?');
      link.setAttribute('href', `mailto:${email}${queryIndex < 0 ? '' : href.slice(queryIndex)}`);
      ['title', 'aria-label'].forEach((attribute) => {
        if (link.hasAttribute(attribute)) {
          link.setAttribute(attribute, link.getAttribute(attribute).replace(pattern, email));
        }
      });
    });
  });
})();
